
angular.module('bmsApp.crm.customer').controller('CustomerMainCtrl', [
	'$scope', function (
		$scope) {
		
		console.log('I have been loaded');
		
		$scope.$on('customerIndexUpdated', function (e, customerData) {
			$scope.customerData = customerData;
		});
		
	}]);
